import React, { useState, useRef, useEffect, useContext } from "react";
import { Form, Input, Button, Row, Col, Drawer, message } from 'antd';

import AddLookupDetails from 'modules/lookup_table/add_lookup_values/addLookupDetails';
import { searchPaymentTermAPI } from "services/lookup_table/payment_terms";
import { searchVatInputAPI } from "services/lookup_table/vat_input";
import { searchStatusAPI } from "services/lookup_table/status";
import { searchUnitsAPI } from "services/lookup_table/units";
import { searchCurrencyAPI } from "services/lookup_table/currency";
import { searchBankAPI } from "services/lookup_table/bank";
import { searchPaymentMethodAPI } from "services/lookup_table/payment_method";
import { searchEwtAPI } from "services/lookup_table/ewt";
import { UserAccessContext } from "context/userAccess";

function SearchLookupForm(props) {
    const { userAccess } = useContext(UserAccessContext);
    const createRight = userAccess['lkpSetup'].create;

    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const showDrawer = () => { setOpen(true); };
    const onClose = () => { setOpen(false); };
    
    const formRef = useRef();

    function drawerClose(value) {
        form.resetFields(); 
        setOpen(value);
    }

    function refreshTblData(values) {
        if(values){
            handleSubmit({searchValue:''});
        }
    };

    async function handleSubmit(formValues){
        try {

            if(props.addButton === 'PAYMENT TERM'){
                const response = await searchPaymentTermAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'VAT INPUT'){
                const response = await searchVatInputAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'STATUS'){
                const response = await searchStatusAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'UNIT'){
                const response = await searchUnitsAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'CURRENCY'){
                const response = await searchCurrencyAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'BANK'){
                const response = await searchBankAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'PAYMENT METHOD'){
                const response = await searchPaymentMethodAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'EWT'){
                const response = await searchEwtAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }
            
        } catch (error) {
            console.log('try submit search error', error)
        }
    };

    return(
        <div>
            <Form 
                layout="vertical" 
                onFinish={handleSubmit}
                ref={formRef}
            >
            <Row gutter={[8, 1]} align='bottom'>
                <Col className="gutter-row" span={6} >
                    <Form.Item name='searchValue'>
                        <Input placeholder={props.placeholder} 
                            className='inv-input-uppercase'
                        />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={6} >
                    <Form.Item>
                        <Button
                            className="login-form-button"
                            type="primary"
                            htmlType='submit'
                        >
                            SEARCH
                        </Button>
                        {/* <Button style={{ marginLeft: '5px' }} >
                            Clear
                        </Button> */}
                    </Form.Item>
                </Col>
                {(createRight === 'TRUE')
                ?   <Col className="gutter-row" span={12} >
                        <Form.Item>
                            <Button style={{ float:'right' }} 
                                type="primary"
                                onClick={showDrawer}
                            >
                                ADD {props.addButton}
                            </Button>
                                <Drawer title={"ADD " + props.addButton} placement="right" onClose={onClose}
                                    width="30%"
                                    visible={open}
                                >
                                    <AddLookupDetails 
                                        lookupDet={props.addButton} 
                                        drawerClose={ drawerClose } 
                                        refreshTblData={ refreshTblData }
                                        onCloseDrawer={open}
                                    />
                                </Drawer>
                        </Form.Item>
                    </Col>
                : <></>
                }
            </Row>
            </Form>
        </div>
    )
}

export default SearchLookupForm;